import { render, staticRenderFns } from "./prize-data.vue?vue&type=template&id=43f22bce&scoped=true&"
import script from "./prize-data.vue?vue&type=script&lang=js&"
export * from "./prize-data.vue?vue&type=script&lang=js&"
import style0 from "./prize-data.vue?vue&type=style&index=0&id=43f22bce&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "43f22bce",
  null
  
)

export default component.exports